import { Box } from '@mui/material';
import { IssueForm } from '../components/issueForm';
import { FormSkeleton } from '../components/skeleton';
import { FormStepper } from '../components/stepper';
import { useIdentifyUserAndPage } from '../hooks/useIdentifyUserAndPage';
import { useUserStore } from '../stores/userStore';
import { PageName } from '../utils/locale/identifyUserAndPage';

export const IssueFormView = () => {
    const me = useUserStore((state) => state.me);
    useIdentifyUserAndPage(me?._id, PageName.issue, me?.email);

    if (!me) {
        return <FormSkeleton />;
    }

    return (
        <Box>
            <FormStepper activeStepIndex={0} />
            <IssueForm />
        </Box>
    );
};
